'use client';

import CancellationRetentionNotification from '@/components/Form/CancellationRetention/CancellationRetentionNotification';
import {
  RETENTION_DESKTOP_CTA_LABEL,
  isRetentionNotificationDismissed,
  isRetentionProductSelected,
} from '@/components/Form/CancellationRetention/cancellationRetentionHelper';
import { useCancellationRetentionImpression } from '@/components/Form/CancellationRetention/useCancellationRetentionTracking';
import { useCancellationRetentionViewport } from '@/components/Form/CancellationRetention/useCancellationRetentionViewport';
import { useSettings } from '@/providers/SettingsProvider';
import { useUserStore } from '@/providers/UserStoreProvider';
import type { FormStoryblok } from '@/types/component-types-sb';
import { type FC, useEffect, useState } from 'react';

type CancellationRetentionTeaserProps = {
  productValue: unknown;
  blok: FormStoryblok;
};

const CancellationRetentionTeaser: FC<CancellationRetentionTeaserProps> = ({ productValue, blok }) => {
  const settings = useSettings();
  const { isDesktop, isReady } = useCancellationRetentionViewport();
  const userStore = useUserStore((state) => ({
    loggedIn: state.loggedIn,
    salutation: state.name?.salutation,
    lastname: state.name?.lastname,
  }));

  const isEligible = isRetentionProductSelected(productValue, blok);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    setIsDismissed(isRetentionNotificationDismissed());
  }, []);

  useCancellationRetentionImpression(
    isReady && isEligible && isDesktop && !isDismissed,
    isEligible,
    RETENTION_DESKTOP_CTA_LABEL,
    settings
  );

  if (!isReady || !isEligible || !isDesktop || isDismissed) {
    return null;
  }

  return (
    <CancellationRetentionNotification
      settings={settings}
      loggedIn={userStore.loggedIn}
      salutation={userStore.salutation}
      lastname={userStore.lastname}
      onDismiss={() => setIsDismissed(true)}
      open={!isDismissed}
    />
  );
};

export default CancellationRetentionTeaser;
